import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { SIDEBAR_TYPES } from "@shared/constants";
import { selectors } from "@shared/store";
import { PatientDetailsSidebar } from "@containers/Patient/components/PatientDetailsContainer/";
import { SensorDataSessionDetailsSidebar } from "@containers/SensorDataSession/components";

import MainSidebar, { MainSidebarProps } from "./components/MainSidebar/MainSidebar";

import "./index.scss";

const Sidebar = (props: MainSidebarProps) => {
  const sidebar = useSelector(selectors.getSidebar());

  const Component = useMemo(() => {
    if (!sidebar) {
      return sidebarStrategy();
    }

    return sidebarStrategy(sidebar.type);
  }, [sidebar]);

  return Component ? <div className="sidebar-container">{<Component {...sidebar?.props} {...props} />}</div> : null;
};

const sidebarStrategy = (type?: string) => {
  switch (type) {
    case SIDEBAR_TYPES.PATIENT_DETAILS: {
      return PatientDetailsSidebar;
    }
    case SIDEBAR_TYPES.SESSION_DETAILS: {
      return SensorDataSessionDetailsSidebar;
    }
    case SIDEBAR_TYPES.NONE: {
      return null;
    }
    default: {
      return MainSidebar;
    }
  }
};

export default Sidebar;
